module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "TOC_Contents"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TOC_1toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt2"
  }, [_c('a', {
    attrs: {
      "href": "#/Exer#_idTextAnchor001"
    }
  }, [_vm._v("Exercises")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter One:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI#_idTextAnchor003"
    }
  }, [_vm._v("What is the Way of Fire & Ice?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Two:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI1#_idTextAnchor006"
    }
  }, [_vm._v("The Norse Pagan World")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Three:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI2#_idTextAnchor011"
    }
  }, [_vm._v("The Norse Gods")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Four:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI3#_idTextAnchor014"
    }
  }, [_vm._v("Developing Spiritual Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Five:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI4#_idTextAnchor018"
    }
  }, [_vm._v("Core Values")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Six :")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI5#_idTextAnchor021"
    }
  }, [_vm._v("Runelore")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Seven:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI6#_idTextAnchor028"
    }
  }, [_vm._v("The Art of Seiðr")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Eight:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI7#_idTextAnchor031"
    }
  }, [_vm._v("Finding Community")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('span', {
    staticClass: "TOC-num"
  }, [_vm._v("Chapter Nine:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/WFI8#_idTextAnchor036"
    }
  }, [_vm._v("Building Community")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt2"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI9#_idTextAnchor038"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt2"
  }, [_vm._v("Appendix I: "), _c('a', {
    attrs: {
      "href": "#/WFI10#_idTextAnchor041"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt2"
  }, [_vm._v("Appendix II:  "), _c('a', {
    attrs: {
      "href": "#/WFI11#_idTextAnchor043"
    }
  }, [_vm._v("The Origins of the Pagan Revival")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt2"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI12#_idTextAnchor044"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0